import type { Element } from 'react';
// @flow
import type { GridLayout } from './Grid';

export default class SimpleGridLayout implements GridLayout {
  +direction: 'row' | 'column';
  +spec: string;
  +children: Array<Element<any>>;
  +childRules: string = '';

  constructor(direction: 'row' | 'column', spec: string, children: Array<Element<any>>) {
    this.direction = direction;
    this.spec = spec;
    this.children = children;
  }

  get templateSpec(): string {
    if (this.direction === 'column') {
      return `${this.spec} / auto`;
    }
    return `auto / ${this.spec}`;
  }
}
